import React, { useMemo } from 'react';
import { CssBaseline, ThemeOptions } from '@mui/material';
import { frFR } from '@mui/x-data-grid';
import { frFR as coreFR } from '@mui/material/locale';
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { palette } from './palette';
// import { typography } from './typography';
import { ComponentsOverrides } from './overrides';

interface ThemeProps {
    children: React.ReactElement;
}

export function ThemeConfig({ children }: ThemeProps): React.ReactElement {
    const themeOptions: ThemeOptions = useMemo(
        () => ({
            palette
            // typography
        }),
        []
    );
    const theme = createTheme(themeOptions);
    theme.components = ComponentsOverrides(theme);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                {/* <CssBaseline /> */}
                {children}
            </ThemeProvider>
        </StyledEngineProvider>
    );
}
